<template>
  <button class="login-m-btn" @click="handleDidsLogin">
    <!-- <GoogleLogo /> -->
    <span>Did</span>
  </button>
</template>


<script>
import GoogleLogo from '@/decast/icons/GoogleLogo.vue';
import constants from '../../../../../constant';
const EXTENSION_ID = constants.didManagerExtensionKey;

export default {
  name: "DidsLogin",
  components: {
    GoogleLogo,
  },
  data() {
    return {
      nonce: '',
      isLoading: false,
      errorMessage: '',
      selectedDid: '',
    }
  },
  async mounted() {
    document.getElementById('loading-bg-transparent').style.display = 'none';
    window.addEventListener('message', this.handleDidSelected);
  },
  beforeUnmount() {
    window.removeEventListener('message', this.handleDidSelected);
  },
  methods: {
    async handleDidsLogin() {
      this.isLoading = true;
      this.errorMessage = '';

      if (window.chrome && chrome.runtime) {
        chrome.runtime.sendMessage(
          EXTENSION_ID,
          { action: 'open-did-popup' },
          (response) => {
            if (chrome.runtime.lastError) {
              this.isLoading = false;
              this.errorMessage = 'Extension not available';
            }
          }
        );

        window.addEventListener('message', this.handleDidSelected);
      } else {
        this.isLoading = false;
        this.errorMessage = 'Extension API not available';
        this.$vs.notify({
          title: 'Request Unsuccessful',
          text: 'Extension not installed or not available',
          iconPack: 'feather',
          icon: 'icon-check-circle',
          color: 'danger',
        });
        window.location.href = 'https://chrome.google.com/webstore/detail/decast-did-manager/' + EXTENSION_ID;
        return;
      }
    },

    async handleDidSelected(event) {
      if (event.data?.action !== 'did-selected') return;

      window.removeEventListener('message', this.handleDidSelected);

      try {
        const { did } = event.data;
        this.selectedDid = typeof did === 'string' ? did : did?.did || '';
        console.log("[Decast] DID selected:", did);

        const payload = did
        console.log("[Decast] Dispatching v2getDidNonce with payload:", payload);
        this.$store
          .dispatch('auth/v2getDidNonce', payload)
          .then((response) => {
            const { nonce, token } = response.data;
            // console.log("[Decast] Nonce received from API:", nonce);
            chrome.runtime.sendMessage(
              EXTENSION_ID,
              { action: "sign-nonce", nonce, did },
              (response) => {
                if (chrome.runtime.lastError) {
                  this.errorMessage = 'Error communicating with extension';
                } else {
                  this.$vs.notify({
                    title: 'Success',
                    text: 'Nonce sent to extension for signing',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success',
                  });
                  // console.log("[Decast] Nonce sent to extension for signing");
                }
              }
            );

            window.addEventListener('message', (e) => this.handleNonceSigned(e, token));
          })
          .catch((error) => {
            // Safely extract the specific error message
            const errorResponse = error.response?.data;
            let message = "An error occurred.";
            if (errorResponse?.errors?.email) {
              message = "Account does not exist!";
            } else if (typeof errorResponse?.errors === 'string') {
              message = errorResponse.errors;
            }
            // this.$vs.notify({
            //   title: 'Login Failed',
            //   text: message,
            //   iconPack: 'feather',
            //   icon: 'icon-alert-circle',
            //   color: 'danger',
            // });
          }).finally(() => { });
      } catch (err) {
        this.isLoading = false;
        this.errorMessage = err.message;
      }
    },

    async handleNonceSigned(event, token) {
      // console.log("[Decast] Handling nonce signed event");
      // console.log("[Decast] Event data:", event.data, event.data?.action);
      if (event.data?.action !== 'nonce-signed') return;

      window.removeEventListener('message', this.handleNonceSigned);

      if (event.data.error) {
        this.$vs.notify({
          title: 'Nonce Signing Canceled',
          text: event.data.error,
          iconPack: 'feather',
          icon: 'icon-check-circle',
          color: 'warning',
        });
        this.isLoading = false;
        this.errorMessage = event.data.error;
        return;
      }

      // this.$vs.notify({
      //   title: 'Success',
      //   text: 'Nonce signed successfully',
      //   iconPack: 'feather',
      //   icon: 'icon-check-circle',
      //   color: 'success',
      // });

      const { signature } = event.data;
      console.log("[Decast] Nonce signed by extension:", signature);

      try {
        console.log("[Decast] Preparing DID Document for login");

        const didDocument = {
          '@context': 'https://www.w3.org/ns/did/v1',
          id: this.selectedDid,
          verificationMethod: [{
            id: `${this.selectedDid}#keys-1`,
            type: 'Ed25519VerificationKey2018',
            controller: this.selectedDid,
            publicKeyBase58: this.selectedDid.split(':').pop(),
          }],
          authentication: [`${this.selectedDid}#keys-1`],
        };

        console.log("[Decast] DID Document prepared2:", didDocument);

        const payload = {
          token,
          signature,
          didDocument,
        };
        console.log("[Decast] Dispatching v2loginWithDid with payload:", payload);
        this.$store.dispatch('auth/v2loginWithDid', payload)
          .then((response) => {
            console.log("[Decast] Login response:", response.data);
            const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
            if (isTwoFactorAuthEnabled) {
              //ask for 2fa
              const twoFactorToken = response.data?.token;
              this.$router.push({ name: 'TwoFactor', query: { tempToken: twoFactorToken } });
            } else {
              this.$store.commit('auth/SET_LOGGEDIN', true);
              this.$acl.change('user');
              this.$vs.notify({
                title: 'Login Successful',
                text: 'Redirecting to dashboard!',
                iconPack: 'feather',
                icon: 'icon-check-circle',
                color: 'success',
              });
              this.$router.push('/dashboard/rooms');
            }
          })
          .catch((error) => {

            console.log(error, 'login error');
            // this.$vs.notify({
            //   text: error,
            //   iconPack: 'feather',
            //   icon: 'icon-alert-circle',
            //   color: 'warning',
            // });
          }).finally(() => {
            this.isLoading = false;
            document.getElementById('loading-bg-transparent').style.display = 'none';
          });
      } catch (err) {
        this.errorMessage = err.message;
        this.isLoading = false;
      }
    },
  }
}
</script>

<style scoped>
.login-m-btn {
  height: 50px !important;
  width: 50px !important;
  background-color: #1B1D29 !important;
  border: 1px solid #242632 !important;
  border-radius: 4px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-m-btn svg {
  height: 18px !important;
  width: 18px !important;
}

.login-m-btn span {
  color: #FFFFFF70;
}
</style>